module.exports = __webpack_public_path__ + "static/media/robots.3ad0652b.txt";